import React from 'react';
import './styles.css';

const RgrLogo = () => (
    <div className='RgrLogo'>
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M2.04586 12.5091L8.58183 1.16362L11.7706 6.6909H7.39535L4.0499 12.5091H2.04586ZM8.00001 5.52729L8.58183 4.50911L9.16365 5.52729H8.00001Z' fill='white' />
            <path fillRule='evenodd' clipRule='evenodd' d='M1.71068 13.0909L0.872742 14.5454H7.85456L9.0182 12.5091H15.1273L13.2811 9.30909H9.18621L7.00439 13.0909H1.71068ZM9.74547 11.3455H12.6546L12.2182 10.4727H10.1818L9.74547 11.3455Z' fill='white' />
            <path d='M12.9455 8.72727L12.1063 7.27272H7.73195L4.72104 12.5091H6.66836L8.85018 8.72727H12.9455Z' fill='white' />
        </svg>
    </div>
);

export default RgrLogo;
